import React from 'react';

import Button from 'components/Button';

import {EditDescriptionForm} from './components';

import './styles.css';

interface RoomCheckDescriptionProps {
  description: string;
  editFormName: string;
  submitEditDescriptionForm: ({newDescription: string}) => any;
  edittingDescription: boolean;
}

class RoomCheckDescription extends React.Component<RoomCheckDescriptionProps> {
  state = {
    editDescription: false
  };

  setEditDescription = () => {
    this.setState({editDescription: true});
  };

  unsetDescriptionForEdit = () => {
    this.setState({editDescription: false});
  };

  submitEditDescriptionForm = ({newDescription}) => {
    this.props.submitEditDescriptionForm({newDescription});

    this.unsetDescriptionForEdit();
  };

  render() {
    const {description, editFormName, edittingDescription} = this.props;
    const {editDescription} = this.state;

    return (
      <div className="RoomCheckDescription">
        <div className="RoomCheckDescription--label colab-bold">
          Description
        </div>

        {!editDescription &&
          !edittingDescription && (
            <div className="RoomCheckDescription--text">
              <div>{description}</div>
              <Button white onClick={this.setEditDescription}>
                Edit
              </Button>
            </div>
          )}
        {(editDescription || edittingDescription) && (
          <EditDescriptionForm
            description={description}
            hideEditDescriptionForm={this.unsetDescriptionForEdit}
            submitAction={this.submitEditDescriptionForm}
            formName={editFormName}
          />
        )}
      </div>
    );
  }
}

export default RoomCheckDescription;
